'use strict';

var React = require('react'),
    ContextMenu = require('../molecules/ContextMenu'),
    Link = require('../atoms/Link'),
    Icon = require('../atoms/Icon'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { isMobile } = require('../utils/Browser');

var CreateStampOrZineContextMenu = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    anchorRect: React.PropTypes.object.isRequired
  },

  render() {
    var canCreateStamp = !isMobile();

    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        {canCreateStamp &&
          <Link propagateClick
                to='draftCompose'
                params={{ stampSegment: 'new' }}
                context='ContextMenu'
                underline='never'
                bold>
                <Icon name='stamp'
                      size='large'
                      mode='stroke'
                      style={{ color: '#abadb3' }}
                      context='link' />
                New Stamp
          </Link>
        }

        {canCreateStamp &&
          <ContextMenu.Separator />
        }

        <Link propagateClick
              to='zineNew'
              context='ContextMenu'
              underline='never'
              bold>
              <Icon name='zine'
                    size='large'
                    mode='stroke'
                    style={{ color: '#abadb3' }}
                    context='link' />
              New Collection
        </Link>
      </ContextMenu>
    );
  }
});

module.exports = CreateStampOrZineContextMenu;



/** WEBPACK FOOTER **
 ** ./contextMenus/CreateStampOrZineContextMenu.jsx
 **/